import { Alert, Card } from 'ui';

const EventDetailStatusMessage = () => (
  <Card>
    <Alert description="This event has been canceled by author" title="Canceled" type="error" />
  </Card>
);

export default EventDetailStatusMessage;
